/**
 * Customer Welcome Email Service
 * Sends welcome email to new customers with:
 * - Welcome message
 * - List of benefits
 * - App Store and Play Store links
 * - QR codes for app downloads
 */

interface Customer {
  id: string;
  email: string;
  name: string;
}

interface CustomerWelcomeEmailData {
  customer: Customer;
  appStoreUrl: string;
  playStoreUrl: string;
  webAppUrl: string;
}

class CustomerWelcomeEmailService {
  private readonly API_BASE_URL = __DEV__
    ? 'http://localhost:3000/api'
    : 'https://bookapt-payment-api.herokuapp.com/api';
  
  // App Store and Play Store URLs (update with actual URLs when apps are published)
  private readonly APP_STORE_URL = 'https://apps.apple.com/app/bookapt/id123456789'; // Update with actual App Store URL
  private readonly PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.bookapt.app'; // Update with actual Play Store URL
  private readonly WEB_APP_URL = __DEV__
    ? 'http://localhost:3001'
    : 'https://app.bookapt.io';

  /**
   * Send welcome email to new customer
   */
  async sendWelcomeEmail(customer: Customer): Promise<boolean> {
    try {
      console.log('📧 Sending customer welcome email to:', customer.email);

      // Get app store URLs
      const appStoreUrl = this.APP_STORE_URL;
      const playStoreUrl = this.PLAY_STORE_URL;
      const webAppUrl = this.WEB_APP_URL;

      const emailData: CustomerWelcomeEmailData = {
        customer,
        appStoreUrl,
        playStoreUrl,
        webAppUrl,
      };

      // Send email via backend API
      const response = await fetch(`${this.API_BASE_URL}/email/send-customer-welcome`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(emailData),
      });

      const result = await response.json();

      if (result.success) {
        console.log('✅ Customer welcome email sent successfully');
        return true;
      } else {
        console.error('❌ Failed to send customer welcome email:', result.error);
        return false;
      }
    } catch (error) {
      console.error('❌ Error sending customer welcome email:', error);
      return false;
    }
  }
}

export const customerWelcomeEmailService = new CustomerWelcomeEmailService();
export default customerWelcomeEmailService;
